import { PageHead } from "@/components/PageHead";
import { AffiliateForm } from "@/components/AffiliateForm";

export default function JoinPartner() {
  return (
    <div data-testid="join-partner-page">
      <PageHead eyebrow="For Financial Professionals" title="Become a DhanTrove verified partner." sub="Brokers, AMFI distributors, insurers, RERA developers and SEBI-registered advisors — reach retail investors across India." />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16 -mt-8"><AffiliateForm /></div>
    </div>
  );
}
